// SPDX-License-Identifier: MIT
// Copyright (c) 2022 The Pybricks Authors

import tour from './redux/tour';

export default tour;
